<template>
  <div class="wg-row">
    <!-- Groups -->
    <div
      class="wg-row com-anm22-app-scrolling-panel"
      v-for="(col, index) in customView.cols"
      :key="'group-' + index"
      style="max-height: calc(100vh - 220px);"
    >
      <!-- Group headers -->
      <div id="list-groups-labels" class="wg-row list-groups-labels">
        <div
          class="wg-row wg-xs-12 com-anm22-app-text-l group-label"
          @click="toggleGroup(col.id)"
        >
          <span
            class="group-toggle"
            :class="{ open: isGroupExpanded(col.id) }"
          >&gt;</span>
          {{ col.name }}
          <span v-if="colsObjectsData[col.id]" class="group-count">
            ({{ colsObjectsData[col.id].all.length }})
          </span>
        </div>
      </div>
      <!-- Group item -->
      <div
        v-if="isGroupExpanded(col.id)"
        :key="'kanban-col-' + index"
        :id="'status-projects-list-colid-' + col.id"
        class="wg-row wg-xs-12 status-projects-list"
        style="padding:0 5px;"
      >
        <template v-if="separateUrgent">
          <object-bar
            v-for="odata in colsObjectsData[col.id].urgent"
            :key="col.id + '-u-' + odata.id"
            :objectData="odata"
            :view="'cols'"
          ></object-bar>
          <div
            v-if="
              colsObjectsData[col.id].urgent.length &&
                colsObjectsData[col.id].notUrgent.length
            "
            class="separator"
          ></div>
          <object-bar
            v-for="odata in colsObjectsData[col.id].notUrgent"
            :key="'colid-' + col.id + '-' + odata.id"
            :objectData="odata"
            :view="'cols'"
          ></object-bar>
        </template>
        <object-bar
          v-else-if="colsObjectsData && colsObjectsData[col.id].all"
          v-for="odata in colsObjectsData[col.id].all"
          :key="'colid-' + odata.id"
          :objectData="odata"
          :view="'cols'"
        ></object-bar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ObjectBar from "../project/ObjectBar.vue";

export default {
  components: {
    ObjectBar,
  },
  props: {
    projectsData: {
      type: Array,
      required: true,
    },
    customView: {
      type: Object,
      required: true,
      default: {
        id: null,
        type: "jobs",
        jobs: [],
      },
    },
    sortingFunctionGenerator: {
      type: Function,
      required: true,
    },
    separateUrgent: {
      type: Boolean,
      default: false,
    },
    orderingField: {
      type: String,
      default: "deadline",
    },
    orderingDir: {
      type: String,
      default: "ASC",
    },
  },
  data() {
    return {
      objectsData: [],
      expandedGroups: {},
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
    }),
    storageKey() {
      return (
        "anm22tasks-groups-list-expanded-" +
        (this.user ? this.user.idWorldUser : "") +
        "-" +
        this.customView.id
      );
    },
    viewJobs() {
      return this.customView.jobs;
    },
    statusList() {
      let statusList = [];
      this.customView.cols.forEach((col) => {
        statusList.push("colid-" + col.id);
      });
      return statusList;
    },
    colsObjectsData() {
      let colsObjectsData = {};

      this.customView.cols.forEach((col) => {
        let colContent = {
          all: this.objectsData.filter(col.rules),
          urgent: [],
          notUrgent: [],
        };

        if (this.separateUrgent) {
          colContent.urgent = colContent.all
            .filter((p) => p.urgent)
            .sort(
              this.sortingFunctionGenerator(
                this.orderingField,
                this.orderingDir,
              ),
            );
          colContent.notUrgent = colContent.all
            .filter((p) => !p.urgent)
            .sort(
              this.sortingFunctionGenerator(
                this.orderingField,
                this.orderingDir,
              ),
            );
        } else {
          colContent.all = colContent.all.sort(
            this.sortingFunctionGenerator(this.orderingField, this.orderingDir),
          );
        }

        colsObjectsData[col.id] = colContent;
      });

      return colsObjectsData;
    },
  },
  methods: {
    loadData() {
      this.$http
        .get(this.customView.endpoint)
        .then((response) => {
          if (response.data) {
            this.objectsData = response.data.objects;
          }
        })
        .catch((error) => console.log(error));
    },
    isGroupExpanded(colId) {
      return !!this.expandedGroups[colId];
    },
    toggleGroup(colId) {
      if (this.isGroupExpanded(colId)) {
        this.$delete(this.expandedGroups, colId);
      } else {
        this.$set(this.expandedGroups, colId, true);
      }
      this.saveExpandedGroups();
    },
    loadExpandedGroups() {
      let expandedGroups = {};
      try {
        const stored = JSON.parse(localStorage.getItem(this.storageKey));
        if (Array.isArray(stored)) {
          stored.forEach((colId) => {
            expandedGroups[colId] = true;
          });
        }
      } catch (e) {
        // Storage not available: all groups collapsed
      }
      this.expandedGroups = expandedGroups;
    },
    saveExpandedGroups() {
      try {
        localStorage.setItem(
          this.storageKey,
          JSON.stringify(Object.keys(this.expandedGroups)),
        );
      } catch (e) {
        // Storage not available: state is not persisted
      }
    },
  },
  watch: {
    storageKey() {
      this.loadExpandedGroups();
    },
  },
  created() {
    this.loadExpandedGroups();
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
.list-groups-labels {
  align-items: center;

  div {
    font-weight:bold;
    justify-content:left;
    padding: 10px;
  }

  .group-label {
    cursor: pointer;
    user-select: none;
  }

  .group-toggle {
    display: inline-block;
    margin-right: 8px;
    padding: 0;
    transition: transform 0.15s;

    &.open {
      transform: rotate(90deg);
    }
  }

  .group-count {
    margin-left: 6px;
    padding: 0;
    font-weight: normal;
    opacity: 0.6;
  }
}
.separator {
  background-color: #fff;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  border-bottom: 2px solid #ddd;
  margin-bottom: 8px;
  height: 1px;
}
.none {
  display: none;
}
.status-projects-list {
  max-height: calc(100vh - 270px);
}
@media screen and (max-width: 990px) {
  .status-projects-list {
    max-height: calc(100vh - 312px);
  }
}
</style>
